import React, { useState } from "react";
import ReportTable from "../subComponents/reportTable";
import { columnsConfig } from "../reportColumns";
import ReportFilters from "../subComponents/reportFilter";

const LowStockReport: React.FC = () => {
  const [filterInputs, setFilterInputs] = useState({
    fromDate: "",
    toDate: ""
  });

  const [filters, setFilters] = useState({
    fromDate: "",
    toDate: ""
  });

  const handleApplyFilters = () => {
    setFilters(filterInputs);
  };

  const handleResetFilters = () => {
    const empty = { fromDate: "", toDate: "" };
    setFilterInputs(empty);
    setFilters(empty);
  };

  return (
    <div>
      <ReportFilters
        filters={filterInputs}
        setFilters={setFilterInputs}
        onApply={handleApplyFilters}
        onReset={handleResetFilters}
      />
      <ReportTable
        title="Low Stock Report"
        endpoint="reports/low-stock"
        columns={columnsConfig.lowStockColumns}
        filters={filters}
      />
    </div>
  );
};

export default LowStockReport;